import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { RouterLink } from '@angular/router';
import { AvatarComponent } from '../../../../../ui-components/lib/avatar/avatar.component';
import { TreeNode } from '../horizontal-tree.model';
import { BadgeComponent } from '../../../../../ui-components/lib/badge/badge.component';
import { TrimTooltipDirective } from '../../../../../ui-components/directives/trim-tooltip/trim-tooltip.directive';
import { TooltipDirective } from '../../../../../ui-components/lib/tooltip/tooltip.directive';
import { ViewIconComponent } from '@kuiper/icons';

@Component({
  selector: 'lib-horizontal-tree-card',
  imports: [
    AvatarComponent,
    BadgeComponent,
    TrimTooltipDirective,
    TooltipDirective,
    NgTemplateOutlet,
    RouterLink,
    ViewIconComponent,
  ],
  templateUrl: './horizontal-tree-card.component.html',
  styleUrl: './horizontal-tree-card.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class HorizontalTreeCardComponent {
  node = input.required<TreeNode>();
  isNoneSelected = input<boolean | undefined>();
  showTitle = input<boolean>(true);
  selectedCard = output<TreeNode>();

  onCardClick() {
    this.selectedCard.emit(this.node());
  }
}
